import { render, staticRenderFns } from "./table-fixed.vue?vue&type=template&id=2936f761&scoped=true"
import script from "./table-fixed.vue?vue&type=script&lang=js"
export * from "./table-fixed.vue?vue&type=script&lang=js"
import style0 from "./table-fixed.vue?vue&type=style&index=0&id=2936f761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936f761",
  null
  
)

export default component.exports